export default __webpack_public_path__ + "static/media/help.ba3862fc.svg";